import { useState, useEffect, FC } from "react";
import { Link, useNavigate } from "react-router-dom";
import css from './index.module.css';
import Logo from '@assets/images/logo.svg';
import useUserData from "@hooks/useUserData";
import Popup from "@components/popup";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

export default function Header() {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [activePopup, setActivePopup] = useState(null); 
    const { userData, projects } = useUserData();

    return (
    <>
        <header className={`${css.header}`}>
            <div className={css.body}>
                <div className={css.leftMenu}>
                    <img src={Logo} alt="Logo" className={css.logo} onClick={() => navigate('/')} />
                    
                    <div className={css.project} onClick={() => setShowModal(true)}>
                        <a style={{ fontSize: 16 }}>{projects?.find(i => i.id.toString() === userData?.project)?.name}</a>
                        <i className="fi fi-rr-angle-small-right"></i>
                    </div>

                    <div className={css.menu}>
                        <Link to={`/`}>Контейнеры</Link>
                        <Link to={`/support`}>Поддержка</Link>
                        <Link to={`/documents`}>Документы</Link>
                        <Link to={`https://dash.leecyber.com/spage/artcons`} target="_blank">Статус сервиса</Link>
                        <Link to={`/partners`}>Партнерская программа</Link>

                        {userData?.access! >= 1 &&
                        <>
                            <b style={{ marginTop: 20 }}>Админ-управление</b>
                            <Link to={`/admin`}>Главная</Link>
                            <Link to={`/admin/tickets`}>Обращения</Link>
                            <Link to={`/admin/containers`}>Контейнеры</Link>
                            <Link to={`/admin/users`}>Пользователи</Link>
                            <Link to={`/admin/invoices`}>Выставленные счета</Link>
                            <Link to={`/admin/blog`}>Блог</Link>
                        </>
                        }
                    </div>
                </div>

                <div className={css.rightMenu}>
                    <Link className={css.wallet} to={'/wallet'}>
                        <i className="fi fi-rr-wallet"></i>
                        <a>{userData?.balance} ₽</a>
                    </Link>
                    <Link to={`/account`}><img className={css.avatar} src={'https://avatars.mds.yandex.net/i?id=e3583305ecf833845bce0d64157b63b5_l-5220445-images-thumbs&n=13'} alt="avatar" /></Link>
                </div>
            </div>
        </header>
        <ChangeProject showModal={showModal} setShowModal={setShowModal} />
    </>
    )
}

interface Modal {
    showModal: boolean; 
    setShowModal: any;
}
  
export const ChangeProject:FC<Modal> = ({ showModal, setShowModal }) => {
    const { t } = useTranslation();
    const [page, setPage] = useState<number>(0);
    const [editProject, setEditProject] = useState<{ id: string; name: string } | null>(null);
    const { projects, userData, refreshUserData, refreshProjectData } = useUserData();

    useEffect(() => {
        setPage(0);
        setEditProject(null);
    }, [showModal]);

    const handleChange = async (id: string) => {
      axios.post(`${import.meta.env.VITE_API_URL}/user/project`, { id: id }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('authToken')
        }})
        .then(async (_) => {
            toast.success('Проект изменен');
            refreshUserData();
        });
    };

    const handleSubmit = (event: any) => {
        event.preventDefault();
        const formData = new FormData(event.target);

        axios.post(`${import.meta.env.VITE_API_URL}/user/projects`, formData, {
          headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + localStorage.getItem('authToken')
          }})
          .then(async (_) => {
              toast.success('Проект создан');
              refreshProjectData();
              setPage(0);
          });
    };

    const handleSubmitRename = (event: any) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const id = formData.get('id');

        axios.post(`${import.meta.env.VITE_API_URL}/user/project/${id}`, formData, {
          headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + localStorage.getItem('authToken')
          }})
          .then(async (_) => {
              toast.success('Название проекта изменено');
              refreshProjectData();
              setPage(0);
          });
    };

    return (
        <Popup showPopup={showModal} setShowPopup={setShowModal}>
            {page === 0 ?
                <>
                    <h5 style={{ fontSize: '20px', marginBottom: 10, marginTop: 0 }}>Выберите проект <i className="fi fi-rr-circle-xmark" onClick={() => setShowModal(false)} style={{ float: 'right', fontSize: 17, position: 'relative', top: 2, cursor: 'pointer' }}></i></h5>

                    <div className={css.projects}>
                        {projects?.map(item => {
                            const isCurrent = item.id.toString() === userData?.project;

                            return (
                                <div
                                  key={item.id}
                                  className={`${css.projectItem} ${isCurrent ? css.projectItemActive : ''}`}
                                >
                                    <div
                                      className={css.projectItemMain}
                                      onClick={() => handleChange(item.id.toString())}
                                    >
                                        <div className={css.projectTitleRow}>
                                            <span className={css.projectName}>{item.name}</span>
                                            {isCurrent && (
                                                <span className={css.projectBadge}>Текущий проект</span>
                                            )}
                                        </div>
                                        <span className={css.projectSubtitle}>
                                            Рабочий проект для всех разделов
                                        </span>
                                    </div>

                                    <div className={css.projectItemActions}>
                                        <button
                                          type="button"
                                          className={css.projectActionBtn}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setEditProject({ id: item.id.toString(), name: item.name });
                                            setPage(2);
                                          }}
                                        >
                                            <i className="fi fi-rr-pencil"></i>
                                        </button>
                                    </div>
                                </div>
                            );
                        })}

                        <div
                          className={`${css.projectItem} ${css.projectAdd}`}
                          onClick={() => {
                            setEditProject(null);
                            setPage(1);
                          }}
                        >
                            <div className={css.projectItemMain}>
                                <span className={css.projectName}>Добавить новый проект</span>
                                <span className={css.projectSubtitle}>
                                    Создайте профиль под новый бизнес
                                </span>
                            </div>
                            <div className={css.projectItemActions}>
                                <div className={css.projectAddIcon}>
                                    <i className="fi fi-rr-plus-small"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            : page === 1 ?
                <>
                    <h5 style={{ fontSize: '20px', marginBottom: 10, marginTop: 0 }}>Создать проект</h5>

                    <form className={css.form} onSubmit={handleSubmit}>
                        <input placeholder="Название проекта" name="name" required />
                        <button type="submit" style={{ width: '100%' }}>Продолжить</button>
                    </form>   
                </> 
            :
                <>
                    <h5 style={{ fontSize: '20px', marginBottom: 10, marginTop: 0 }}>Переименовать проект</h5>

                    <form className={css.form} onSubmit={handleSubmitRename}>
                        <input type="hidden" name="id" value={editProject?.id || ''} />
                        <input placeholder="Название проекта" name="name" defaultValue={editProject?.name} required />
                        <button type="submit" style={{ width: '100%' }}>Сохранить</button>
                    </form>   
                </>
            }
        </Popup>
    );
  }
  